module.exports = __webpack_public_path__ + "static/media/ui_guide_image.8272d370.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/MobileApp/assets/ui_guide_image.png
// module id = 553
// module chunks = 0